import { getSiteBrand } from "@/lib/siteHosts";

export const LIVE_PROOF_STAMP = "LIVE PROOF";
export const LIVE_PROOF_TAG = "REAL CONVERSATION";

export const LIVE_PROOF_HEADLINE = {
  get lead() {
    return `Watch ${getSiteBrand().name} Digital Employee Qualify & Book a`;
  },
  accentPrimary: "Roof Repair Lead",
  leadMid: "in Under",
  accentSecondary: "7 Minutes",
};

export const LIVE_PROOF_SUBHEAD =
  "Real conversation log from a live Oz Exteriors roofing deployment. Zero human intervention, instant response times, and automated calendar sync.";

export const LIVE_PROOF_PRIVACY_NOTE =
  "Privacy Note: Personal Identifiable Information (PII) like phone numbers and exact addresses have been replaced with mock data.";

export const LIVE_PROOF_STATS = [
  { value: "7 min", label: "Lead to booked", sub: "Real deployment timeline" },
  { value: "~8s", label: "Avg response", sub: "24/7 availability" },
  { value: "Booked ✓", label: "Site visit", sub: "Synced to calendar" },
];

export const LIVE_PROOF_TIMELINE = [
  { time: "09:08", label: "Lead in" },
  { time: "09:12", label: "Qualified" },
  { time: "09:15", label: "Booked ✓" },
];

export const LIVE_PROOF_TIMELINE_DURATION = "7 min total";

export const LIVE_PROOF_LATENCY_BADGE_LIMIT = 3;

export const LIVE_PROOF_CHAT_HEADER = {
  label: "LIVE CHAT LOG",
  status: "INSPECTION BOOKED",
};

export const LIVE_PROOF_CHAT_HISTORY = [
  {
    role: "assistant",
    response_time_seconds: 9,
    content:
      "Hi, I'm Jack from Oz Exteriors Roofing Group. It's great to meet you! 🏠 Yep, 12 Sample St, Figtree is well within our service area. Got your number, +61400000000, and I've noted the repair request for the property. Are you the owner, tenant, or an agent for this property?",
    timestamp: "2026-10-08T09:08:14.613901+00:00",
  },
  {
    role: "user",
    content: "It's my father's house. His English isn't the best.",
    timestamp: "2026-10-08T09:09:28.141940+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 6,
    content:
      "No worries, Sam. Thanks for letting me know you are helping your father out with the place. To make sure we send the right gear, is this a house, townhouse, unit, commercial building, or strata property?",
    timestamp: "2026-10-08T09:09:34.281240+00:00",
  },
  {
    role: "user",
    content: "It's a house. The aerial pole has fell of and hit the house and broken some tiles.",
    timestamp: "2026-10-08T09:10:28.167294+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 7,
    content:
      "No worries, Sam. Thanks for the update on the damage from the aerial pole and the broken tiles. Since it is a house, is it single, double, or triple storey?",
    timestamp: "2026-10-08T09:10:34.978001+00:00",
  },
  {
    role: "user",
    content: "Double",
    timestamp: "2026-10-08T09:10:58.662298+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 7,
    content:
      "Got it, double storey. How urgent is this, mate? Do you have an active leak now, or are you planning ahead.",
    timestamp: "2026-10-08T09:11:05.138028+00:00",
  },
  {
    role: "user",
    content: "He wants fixed quick cause his worried about if it rains.",
    timestamp: "2026-10-08T09:12:14.702538+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 7,
    content:
      "I understand you're worried about the rain, Sam. We'll make sure to get someone out there to check those tiles as soon as possible. What time of day works best for our technician to come out for the inspection?",
    timestamp: "2026-10-08T09:12:21.688164+00:00",
  },
  {
    role: "user",
    content: "Dad can be home when ever needed as long as we get some sort of notice.",
    timestamp: "2026-10-08T09:13:09.876976+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 10,
    content:
      "No worries, Sam. I have your dad's availability noted, so we'll make sure the team provides notice before they arrive. Since we have all the details on the damage, let's get that inspection booked. I have 9:00 AM, 12:00 PM, or 3:00 PM available tomorrow, October 9th, which of those works best for our technician?",
    timestamp: "2026-10-08T09:13:19.300775+00:00",
  },
  {
    role: "user",
    content: "9am sounds good.",
    timestamp: "2026-10-08T09:13:55.644976+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 9,
    content:
      "No worries, Sam. Since we need a bit more notice for the team, the earliest I can offer is Monday 12 October at 8:00 AM, 8:30 AM, or 9:00 AM. Do any of those suit you? The weather looks clear for those times, so we should be right to get that inspection done.",
    timestamp: "2026-10-08T09:14:04.780449+00:00",
  },
  {
    role: "user",
    content: "8am",
    timestamp: "2026-10-08T09:15:06.531707+00:00",
    message_id: "ghl:customer_replied:mock_contact_id_0000",
  },
  {
    role: "assistant",
    response_time_seconds: 13,
    content:
      "All booked, Sam! ✓ Your inspection is confirmed for Monday, 12 October at 8:00 AM. The technician will arrive between 08:00 AM - 10:00 AM, and you will receive a reminder before the visit. Is there anything else you need help with today?",
    timestamp: "2026-10-08T09:15:19.246627+00:00",
    highlight: true,
  },
];
